import React from 'react';
import {useGetAssetPathQuery} from 'src/redux/queries/asset';
import type {IFormFieldV2} from 'src/types/FormV2';
import {FormViewRowV2} from '../FormViewRow/FormViewRowV2';

export interface FormViewAssetSelectorV2Props {
  field: IFormFieldV2;
  value: string | number | undefined;
}

export const FormViewAssetSelectorV2: React.FC<
  FormViewAssetSelectorV2Props
> = ({field, value}) => {
  const {data: asset, isLoading: isAssetLoading} = useGetAssetPathQuery(
    Number(value),
    {skip: !value}
  );

  const displayValue = !value
    ? 'N/A'
    : isAssetLoading
    ? 'Loading...'
    : field.assetOptions?.showFullPath
    ? asset?.path ?? 'Unknown'
    : asset?.name ?? 'Unknown';

  return <FormViewRowV2 field={field} value={displayValue} />;
};
